import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/login/page.tsx");
